import './cartAddOns.scss';
import cartModel from '../cart/cartModel';

import { groupItems } from '../cartList/cartListUtils';

/* eslint-disable no-param-reassign */
const hide = function hideCardAddOn(el) {
  if (!el) {
    return;
  }
  clearTimeout(el.timeoutHideStart);
  clearTimeout(el.timeoutHideEnd);
  clearTimeout(el.timeoutShowEnd);
  const elHeight = el.children[0].offsetHeight;
  el.setAttribute('style', `height: ${elHeight}px`);
  el.timeoutHideStart = setTimeout(() => {
    el.setAttribute('style', 'height: 0');
  }, 50);

  el.timeoutHideEnd = setTimeout(() => {
    el.setAttribute('aria-hidden', 'true');
    el.removeAttribute('style');
  }, 400);
};

const show = function showCardAddOn(el) {
  if (!el) {
    return;
  }
  clearTimeout(el.timeoutHideStart);
  clearTimeout(el.timeoutHideEnd);
  clearTimeout(el.timeoutShowEnd);
  const elHeight = el.children[0].offsetHeight;
  el.setAttribute('style', `height: ${elHeight}px`);
  el.timeoutShowEnd = setTimeout(() => {
    el.setAttribute('aria-hidden', 'false');
    el.removeAttribute('style');
  }, 400);
};
/* eslint-enable no-param-reassign */

const onAddClick = function onAddOnsAddClick(ev) {
  const id = ev.currentTarget.getAttribute('data-id');

  // Find cart frequencies great than 0 - or get the default
  const cartFrequency = (Object.keys(groupItems(cartModel.getState().items)) || [])
    .find(freq => freq * 1) || cartModel.getDefaultFrequency();

  cartModel.add({
    id,
    quantity: 1,
    properties: {
      shipping_interval_frequency: cartFrequency,
      shipping_interval_unit_type: cartModel.getFrequencyUnit(),
    },
  });
};

const render = function renderCartAddOns(props) {
  const {
    items = [],
  } = props;

  const itemHandles = items.map(({ handle }) => handle);
  let countVisible = 0;

  [].forEach.call(
    document.querySelectorAll('.js-cartAddOn'),
    (el) => {
      if (itemHandles.find(handle => handle === el.getAttribute('data-handle'))) {
        hide(el);
      } else {
        countVisible += 1;
        show(el);
      }
    },
  );

  document.querySelector('.js-cartAddOns')
    .setAttribute('aria-hidden', countVisible ? 'false' : 'true');
};

const destroy = function destroyCartAddOns() {
  [].forEach.call(
    document.querySelectorAll('.js-cartAddOnAdd'),
    (el) => {
      el.removeEventListener('click', onAddClick);
    },
  );
};

const bind = function bindCartAddOns() {
  [].forEach.call(
    document.querySelectorAll('.js-cartAddOnAdd'),
    (el) => {
      el.addEventListener('click', onAddClick);
    },
  );
};

const init = function initCartAddOns() {
  cartModel.addCallback(render);
  bind();
};

export default {
  destroy,
  init,
};
